import { c as _c } from "react/compiler-runtime";
import React from 'react';
import classNames from 'classnames';
import { useI18n } from '@udemy-v2/i18n';
import { Icon } from '@udemy-v2/icons';
import { ClpPrimaryCtaButton } from '@/features/course-landing-page/components/clp-primary-cta-button/clp-primary-cta-button.react-component';
import { CourseIncludes } from '@/features/course-landing-page/components/course-includes/course-includes.react-component';
import { MarketplaceUfbNotice } from '@/features/course-landing-page/components/marketplace-purchase-content/marketplace-ufb-notice.react-component';
import { CourseContentPlacement } from '@/features/course-landing-page/course-landing-page.react-component';
import styles from './enrolled-box.module.scss';
import { ClpSecondaryActions } from '@/features/course-landing-page/components/clp-secondary-actions';
interface EnrolledBoxProps {
  placement: CourseContentPlacement;
}

/**
 * EnrolledBox component displays content for non-PP users who have already enrolled in the course.
 * Includes enrolled message, CTA button, course includes, marketplace notice, and money-back guarantee.
 */
export const EnrolledBox = t0 => {
  const $ = _c(22);
  const {
    placement
  } = t0;
  const {
    gettext
  } = useI18n();
  const isSidebarPlacement = CourseContentPlacement.SIDEBAR === placement;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Icon color="info" glyph="info" label={false} />;
    t2 = classNames("ud-text-bold", styles["enrolled-message"]);
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== gettext) {
    t3 = gettext("You purchased this course");
    $[2] = gettext;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <div className={styles["enrolled-message-container"]}>{t1}<span className={t2}>{t3}</span></div>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className={styles["cta-container"]}><ClpPrimaryCtaButton udStyle="primary" /></div>;
    t6 = classNames(styles["money-back-guarantee-container"]);
    $[6] = t5;
    $[7] = t6;
  } else {
    t5 = $[6];
    t6 = $[7];
  }
  let t7;
  if ($[8] !== gettext) {
    t7 = gettext("30-Day Money-Back Guarantee");
    $[8] = gettext;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t7) {
    t8 = <div className={t6}><span className="ud-text-xs" data-purpose="money-back-guarantee">{t7}</span></div>;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== isSidebarPlacement) {
    t9 = isSidebarPlacement && <CourseIncludes />;
    $[12] = isSidebarPlacement;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <ClpSecondaryActions />;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== isSidebarPlacement) {
    t11 = isSidebarPlacement && <MarketplaceUfbNotice />;
    $[15] = isSidebarPlacement;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t11 || $[18] !== t4 || $[19] !== t8 || $[20] !== t9) {
    t12 = <div className={styles.container} data-purpose="enrolled-box">{t4}{t5}{t8}{t9}{t10}{t11}</div>;
    $[17] = t11;
    $[18] = t4;
    $[19] = t8;
    $[20] = t9;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  return t12;
};